export default class Activities
{
    constructor(instructions, basic_info, volunteer_works){
        this.instructions       = instructions
        this.basic_info     = basic_info
        this.volunteer_works      = volunteer_works
    }

    toFormData(){
        let fData = new FormData()
        
        //معلومات المنسق 
        fData.append('name1', this.basic_info.name1);
        fData.append('name2', this.basic_info.name2);
        fData.append('name3', this.basic_info.name3);
        fData.append('name4', this.basic_info.name4);
        fData.append('telegram_link', this.basic_info.telegram);
        fData.append('phone', this.basic_info.phone1);
        fData.append('note_coordinator', this.basic_info.another_coordinator);

        // معلومات البرنامج او النشاط
        fData.append('name', this.volunteer_works.name_volunteer_team);
        fData.append('acceptance_type_id', this.volunteer_works.obtain_approval_id);
        fData.append('program_type_id', this.volunteer_works.activity_type_id);
        if(this.volunteer_works.activity_type_id == '17'){
            fData.append('another_program_type', this.volunteer_works.another_activity_type);
        }
        fData.append('date_program', this.volunteer_works.date_program);
        fData.append('location_program', this.volunteer_works.location_program);
        fData.append('duration_program', this.volunteer_works.duration_program);
        fData.append('question_1_program_goal', this.volunteer_works.program_goal);
        fData.append('question_2_number_target', this.volunteer_works.expected_number_attendees);
        fData.append('question_3_needs', this.volunteer_works.needs);
        fData.append('question_4_characters_attending', this.volunteer_works.characters_attending);
        fData.append('question_5_characters_implement_program', this.volunteer_works.characters_implement_program);
        fData.append('question_6_challenges', this.volunteer_works.challenges);
        fData.append('question_7_number_members', this.volunteer_works.number_members);
        fData.append('description', this.volunteer_works.description);
        fData.append('note', this.volunteer_works.notes);
     
        return fData
    }
}

